<div class="scss-status-label"
    [ngClass]="kind !== StatusKind.Custom ? kind : labelColor"
    [class.label-hover]="clickable"
    [attr.role]="clickable ? 'button' : null"
    [attr.tabindex]="clickable ? 0 : null"
    [attr.aria-busy]="showSpinner ? 'true' : null"
    [ngStyle]="{'cursor': clickable ? 'pointer' : 'inherit'}"
    [matTooltip]="toolTipText" [matTooltipPosition]="toolTipPosition"
    (click)="Clicked()"
    (keydown)="HandleKeyDown($event)"
    (keyup)="HandleKeyUp($event)">
    <div class="scss-status-label-wrapper" [attr.data-sb-qa]="qaTag">
        @if (icon) {
            <lib-icon 
                aria-hidden="true"
                [ngClass]="iconColourClass"
                [icon]="icon"
                [size]="IconSize.TwoExtraSmall">
            </lib-icon>
        }
        <p #label checkTruncate (isTruncated)="LabelIsTruncated($event)" class="text-truncate sb-status-label-max-width">
            <ng-content select="[label]"></ng-content>
        </p>
        @if (showSpinner) {
            <div class="spinner-border spinner-border-sm scss-status-label-spinner" aria-hidden="true"></div>
        }
    </div>

</div>
